/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

/*
    This file contains the redux tool kit code for the state that the Whats New Page uses.
*/

// update POST like array endpoint https://test-my.rutgers.edu/myrutgersapi/widgets/whatsNew/addToLikedList?articleId=0
// remove ike POST endpoint https://test-my.rutgers.edu/myrutgersapi/widgets/whatsNew/removeFromLikedList?articleId=5

export const fetchWhatsNewArticles = createAsyncThunk(
  'fetchWhatsNewArticles',
  async () => {
    const rcpid = localStorage.getItem('rutgersEduRCPID')
    const res = await axios.get(`${process.env.REACT_APP_WHATS_NEW_ENDPOINT}`)
    const data = { data: res.data, rcpid }
    return data
  },
)

const initialState = {
  status: 'idle',
  likedStatus: 'idle',
  data: {
    articles: [],
    likedArticles: [],
  },
}

const whatsNewSlice = createSlice({
  name: 'whatsNewPage',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchWhatsNewArticles.rejected]: (state) => {
      state.status = 'error'
    },
    [fetchWhatsNewArticles.pending]: (state) => {
      state.status = 'pending'
    },
    [fetchWhatsNewArticles.fulfilled]: (state, action) => {
      state.status = 'fulfilled'
      // populate liked state list
      state.data.articles = action.payload.data
      const id = parseInt(action.payload.rcpid, 10)
      action.payload.data.articles.forEach((element) => {
        if (element.likedList.includes(id)) {
          state.data.likedArticles.push(element.id)
        }
      })
    },
  },
})

export const selectWhatsNewData = (state) => state.whatsNew.data
export const selectWhatsNewStatus = (state) => state.whatsNew.status

export default whatsNewSlice.reducer
